import React from 'react';
import { motion } from 'framer-motion';
export function TruthSection() {
  return <section className="w-full bg-[#15202B] py-24 px-6 border-t border-[#B8A99A]/5" data-id="element-158">
      <div className="max-w-3xl mx-auto" data-id="element-159">
        {/* The Hard Truth */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-20" data-id="element-160">
          <span className="text-[#E8614D] font-bold tracking-widest text-sm uppercase mb-4 block" data-id="element-161">
            La verdad incómoda
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-[#F5E6D0] mb-8 font-sans leading-tight" data-id="element-162">
            No te falta disciplina. <br data-id="element-163" />
            <span className="text-[#B8A99A]" data-id="element-164">Te falta un guion.</span>
          </h2>

          <div className="space-y-6 text-lg text-[#B8A99A] font-serif leading-relaxed text-left md:text-center max-w-2xl mx-auto" data-id="element-165">
            <p data-id="element-166">
              A las 3:00 AM tu cerebro no necesita más información. Necesita una
              secuencia corta que lo saque de alerta.
            </p>
            <p data-id="element-167">
              Porque cuando improvisas, haces lo más humano… y lo más
              contraproducente: pelear con el insomnio, tratar de dormir "a la
              fuerza", y convertir la noche en una conversación interna
              interminable.
            </p>
          </div>
        </motion.div>

        {/* Divider */}
        <div className="w-24 h-px bg-[#E8614D]/30 mx-auto mb-20" data-id="element-168" />

        {/* Why Old Solutions Fail */}
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-169">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-170">
            <h3 className="text-2xl font-bold text-[#F5E6D0] mb-6 font-sans" data-id="element-171">
              Por qué lo que ya probaste no te funciona:
            </h3>
            <p className="text-[#B8A99A] font-serif mb-4" data-id="element-172">
              "Higiene del sueño" suena bien… hasta que estás despierta a las
              3:17 AM.
            </p>
            <p className="text-[#B8A99A] font-serif" data-id="element-173">
              La mayoría de consejos se enfocan en "cómo dormirte al inicio".
              Pero tu problema no es ese.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="bg-[#0F1923] p-8 rounded-xl border-l-4 border-[#E8614D]" data-id="element-174">
            <p className="text-[#F5E6D0] text-lg font-medium mb-4" data-id="element-175">
              Tu problema es este:
            </p>
            <p className="text-[#B8A99A] font-serif italic mb-6" data-id="element-176">
              Te despiertas, y la situación escala.
            </p>
            <p className="text-[#F5E6D0] text-xl font-bold" data-id="element-177">
              Y cuando escala, ya no estás "descansando". <br data-id="element-178" />
              <span className="text-[#E8614D]" data-id="element-179">Estás vigilando.</span>
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}